import React, { useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { isEmpty } from "lodash";
import { SetCanSaveEditOrder } from "../../../../../../Redux/actions/actionNames";

const App = () => {
  const dispatch = useDispatch();

  // ================== STATE (معادل mapStateToProps)
  const price = useSelector((state) => state.NewOrder.newOrder.price);
  const pickup = useSelector((state) => state.EditOrder.editOrder.pickup);
  const firstDropOff = useSelector(
    (state) => state.EditOrder.editOrder.dropOffs.firstDropOff
  );
  const otherdropOffs = useSelector(
    (state) => state.EditOrder.editOrder.dropOffs.otherDropOffs
  );

  const orderCustomFieldDefinitions = useSelector(
    (state) => state.ViewTravel.pureData?.customFieldDefinitions
  );

  const pickupCustomFields = useSelector(
    (state) => state.EditOrder.editOrder.pickup.customField || {}
  );

  const firstDropOffCustomFields = useSelector(
    (state) =>
      state.EditOrder.editOrder.dropOffs.firstDropOff.customFields || {}
  );

  const deliveryMethodSetting = useSelector(
    (state) => state.ViewTravel.pureData.deliveryMethod?.setting
  );

  // ================== HELPERS

  const emailValidate = useCallback((email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }, []);

  const orderCustomFieldCheck = useCallback(() => {
    let boollx = true;
    let boolly = true;

    orderCustomFieldDefinitions
      ?.filter((item) => item.stage === "pickup" && item.isRequired)
      .forEach((item) => {
        if (!pickupCustomFields[item.key]) boollx = false;
      });

    firstDropOff?.customFieldDefinitions
      ?.filter((item) => item.stage === "dropoff" && item.isRequired)
      .forEach((item) => {
        if (!firstDropOffCustomFields[item.key]) boolly = false;
      });

    return boollx && boolly;
  }, [
    orderCustomFieldDefinitions,
    pickupCustomFields,
    firstDropOff,
    firstDropOffCustomFields,
  ]);

  const pickupRequiredCheck = useCallback(() => {
    if (!deliveryMethodSetting) return false;

    const name = deliveryMethodSetting.isPickupAddressNameRequired
      ? pickup.fullName?.trim()?.length > 0
      : true;

    const phone = deliveryMethodSetting.isPickupAddressPhoneRequired
      ? pickup.phone?.trim()?.length > 3
      : true;

    const email = deliveryMethodSetting.isPickupAddressEmailRequired
      ? pickup.email &&
        pickup.email.length > 0 &&
        emailValidate(pickup.email)
      : true;

    return name && phone && email;
  }, [deliveryMethodSetting, pickup, emailValidate]);

  const firstDropOffRequiredCheck = useCallback(() => {
    if (!deliveryMethodSetting) return false;

    const name = deliveryMethodSetting.isDropoffAddressNameRequired
      ? firstDropOff.fullName?.trim()?.length > 0
      : true;

    const phone = deliveryMethodSetting.isDropoffAddressPhoneRequired
      ? firstDropOff.phone?.trim()?.length > 3
      : true;

    const email = deliveryMethodSetting.isDropoffAddressEmailRequired
      ? firstDropOff.email &&
        emailValidate(firstDropOff.email)
      : true;

    return name && phone && email;
  }, [deliveryMethodSetting, firstDropOff, emailValidate]);

const otherDropOffRequiredCheck = useCallback(() => {
 
  if (!deliveryMethodSetting) {
     return false;
  }

  if (isEmpty(otherdropOffs)) {
     return true;
  }

  let status = true;

  otherdropOffs.forEach((dropOff, index) => {
 
    // ===== Custom Fields Check =====
    firstDropOff?.customFieldDefinitions
      ?.filter((item) => item.stage === "dropoff" && item.isRequired)
      .forEach((item) => {
        const value = dropOff.customFields?.[item.key];

        if (!value) {
        
          status = false;
        } else {
         }
      });

    // ===== Name Check =====
    if (deliveryMethodSetting.isDropoffAddressNameRequired) {
      if (!dropOff.fullName?.trim()) {
         status = false;
      } else {
       }
    }

    // ===== Phone Check =====
    if (deliveryMethodSetting.isDropoffAddressPhoneRequired) {
      if (dropOff.phone?.trim()?.length <= 3) {
         status = false;
      } else {
       }
    }

    // ===== Email Check =====
    if (deliveryMethodSetting.isDropoffAddressEmailRequired) {
      if (!emailValidate(dropOff.email)) {
         status = false;
      } else {
       }
    }

   });

 

  return status;
}, [deliveryMethodSetting, otherdropOffs, firstDropOff, emailValidate]);

  // ================== Lifecycle (معادل componentWillReceiveProps)

 useEffect(() => {
  const priceDone = !!price?.done;
  const pickupValid = pickupRequiredCheck();
  const customFieldsValid = orderCustomFieldCheck();
  const firstDropValid = firstDropOffRequiredCheck();
  const othersValid = otherDropOffRequiredCheck();

  const canSave =
    priceDone &&
    pickupValid &&
    customFieldsValid &&
    firstDropValid &&
    othersValid;

 
   

  dispatch(SetCanSaveEditOrder(canSave));
}, [
  price,
  pickup,
  firstDropOff,
  otherdropOffs,
  pickupRequiredCheck,
  firstDropOffRequiredCheck,
  otherDropOffRequiredCheck,
  orderCustomFieldCheck,
  dispatch,
]);

  return null;
};

export default App;
